import {
    Autocomplete,
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
    Typography } from '../../ui';
import React,
    { useCallback,
    useMemo } from 'react';
import LoadingPaper from '../../global/LoadingPaper';
import {
  BillFromMachine,
  BillStatus,
  CART_INITIAL_STATE,
  CASHPAY,
  getBasePayMedium,
  InternalBillType,
  isEmpty,
  isNumberEmpty,
  isRoleAllowed,
  OfferType,
  ONLINEPAY,
  PayMedium,
  printDebugLog,
  TRIP_ASSIGNED,
  TRIP_DELIVERED,
  TRIP_RUNNING,
  ROLE_CREATE,
  BILLMGMT,
  ONLINEBILLMGMT
} from '../../../constants/constant';
import { TRIP_STATUS, TRIP_STATUS_BACK } from '../resto-billing/RestBillConstants';
import CouponApply from '../../global/CouponApply';

const RestoBillPayScreen = ({ billType,
    billStatus,
    paymentDetails,
    payLoader,
    isPaid,
    setPaymentDetails,
    isOthHomeDelv,
    setOtherHomeDelv,
    delvNameOth,
    setDelvNameOth,
    hotelDelvTxn,
    externalBillDetails,
    setExternalBillDetails,
    loyalityPointDetails,
    updateByGstDelvCharge,
    updateByOffer,
    fireSnackBarMsg,
    settleDown,
    billedFrom,
    tripDetails,
    setTripDetails,
    riders,
    showSnpDialogForUpdateStatus,
    coupon, appliedCoupon, setCoupon, handleApply, handleRemove

}) => {

    const isOnlineEnabled = (payMedium) => {
        return payMedium === PayMedium.ONLINE || payMedium === PayMedium.BOTH;
    };

    const isCashEnabled = (payMedium) => {
        return payMedium === PayMedium.CASH || payMedium === PayMedium.BOTH;
    };

    const handleInputChange = useCallback((event) => {
        const { name, value } = event.target;
        printDebugLog("handleInputChange", name, value);
        if (name === "isGstAllowed") {
            const gstAllowed = !paymentDetails.isGstAllowed;
            setPaymentDetails(prev => ({
                ...prev,
                isGstAllowed: gstAllowed,
            }))
            updateByGstDelvCharge(gstAllowed, Number(paymentDetails.delvCharge));
        } else if (name === "bofferDenom") {
            const takenDenom = Number(value);
            setPaymentDetails(prev => ({
                ...prev,
                takenDenom: takenDenom,
            }));
            updateByOffer(takenDenom, takenDenom === OfferType.No_Offer ? 0.0 : Number(paymentDetails.takenOffrAmt));
        } else if (name === "bofferAmt") {
            const parsedValue = Number(value) || 0.0;
            setPaymentDetails(prev => ({
                ...prev,
                takenOffrAmt: Number(value),
            }));
            updateByOffer(Number(paymentDetails.takenDenom), parsedValue);
        } else if (name === "delvCharge") {
            const parsedValue = Number(value) || 0.0;
            setPaymentDetails(prev => ({
                ...prev,
                delvCharge: value,
            }));
            updateByGstDelvCharge(paymentDetails.isGstAllowed, parsedValue);
        } else if (name === "delvNameOth") {
            setDelvNameOth(prev => ({
                ...prev, value,
            }))
        } else if (name === "homeDelvId") {
            setExternalBillDetails(prev => ({
                ...prev, homeDelvId: value,
            }));
        } else if (name === "homeDelvOtp") {
            setExternalBillDetails(prev => ({
                ...prev, homeDelvOtp: value,
            }));
        } else if (name === 'onlinePayEnb') {
            const isCashPayEnabled = isCashEnabled(paymentDetails.payMedium);
            const onlineStatus = (paymentDetails.payMedium === PayMedium.ONLINE ||
                paymentDetails.payMedium === PayMedium.BOTH ? false : true
            );
            const rt = Number(paymentDetails.finalPrice);
            setPaymentDetails(prev => ({
                ...prev,
                onlinePayThrough: onlineStatus ? ONLINEPAY : "",
                onlinePayMedium: onlineStatus ? CART_INITIAL_STATE.onlinePayMethod[0] : "",
                payMedium: getBasePayMedium(isCashPayEnabled, onlineStatus),
                onlinePay: !onlineStatus ? 0.0 : isCashPayEnabled ? (rt > 0) ? (rt / 2) : 0.0 : rt,
                cashPay: !isCashPayEnabled ? 0.0 : onlineStatus ? (rt > 0) ? (rt / 2) : 0.0 : rt,
            }));
            handleRemove();
        } else if (name === 'onlinePayAmt') {
            const isCashPayEnabled = isCashEnabled(paymentDetails.payMedium);
            const rt = Number(paymentDetails.finalPrice);
            if (isNumberEmpty(value)) {
                setPaymentDetails(prev => ({
                    ...prev,
                    onlinePay: 0.0,
                    cashPay: isCashPayEnabled ? rt : 0.0,
                    cashTender: 0.0,
                    cashReturn: 0.0,
                }));
            } else {
                const parseValue = Number(value) || 0.0;
                if (parseValue > rt) {
                    fireSnackBarMsg({ msg: `Exceeds Total Amount i.e ${rt}` });
                } else {
                    const mCashPay = isCashPayEnabled ? (rt - parseValue) : 0.0;
                    setPaymentDetails(prev => ({
                        ...prev,
                        onlinePay: parseValue,
                        cashPay: mCashPay,
                        cashTender: 0.0,
                        cashReturn: 0.0,
                    }));
                }
            }
        } else if (name === 'cashPayAmt') {
            const isOnlinePayEnabled = isOnlineEnabled(paymentDetails.payMedium);
            const rt = Number(paymentDetails.finalPrice);
            if (isNumberEmpty(value)) {
                setPaymentDetails(prev => ({
                    ...prev,
                    cashPay: 0.0,
                    onlinePay: isOnlinePayEnabled ? rt : 0.0,
                    cashTender: 0.0,
                    cashReturn: 0.0,
                }));
            } else {
                const parseValue = Number(value) || 0.0;
                if (parseValue > rt) {
                    fireSnackBarMsg({ msg: `Exceeds Total Amount i.e ${rt}` });
                } else {
                    const mOnlinePay = isOnlinePayEnabled ? (rt - parseValue) : 0.0;
                    setPaymentDetails(prev => ({
                        ...prev,
                        cashPay: parseValue,
                        onlinePay: mOnlinePay,
                        cashTender: 0.0,
                        cashReturn: 0.0,
                    }));
                }
            }
        } else if (name === 'cashPayEnb') {
            const isOnlinePayEnabled = isOnlineEnabled(paymentDetails.payMedium);
            const val = (paymentDetails.payMedium === PayMedium.CASH ||
                paymentDetails.payMedium === PayMedium.BOTH ? false : true
            );
            const rt = Number(paymentDetails.finalPrice);
            setPaymentDetails(prev => ({
                ...prev,
                cashPayThrough: val ? CASHPAY : "",
                cashPay: !val ? 0.0 : isOnlinePayEnabled ? (rt > 0) ? (rt / 2) : 0.0 : rt,
                onlinePay: !isOnlinePayEnabled ? 0.0 : val ? (rt > 0) ? (rt / 2) : 0.0 : rt,
                payMedium: getBasePayMedium(val, isOnlinePayEnabled),
            }));
            handleRemove();
        } else if (name === 'cashTender') {
            if (Number(paymentDetails.finalPrice) > 0.0) {
                const isOnlinePayEnabled = isOnlineEnabled(paymentDetails.payMedium);
                const tot = isOnlinePayEnabled ? Number(paymentDetails.cashPay) : Number(paymentDetails.finalPrice);
                const rt = Number(value) - tot;
                if (rt >= 0.0) {
                    setPaymentDetails(prev => ({
                        ...prev,
                        cashTender: Number(value),
                        cashReturn: rt,
                    }));
                } else {
                    setPaymentDetails(prev => ({
                        ...prev,
                        cashTender: value,
                        cashReturn: rt,
                    }));
                    if (rt < 0.0) {
                        fireSnackBarMsg({ msg: `Cash Tender should be more or same as Total Amount i.e ${tot}` });
                    }
                }
            } else {
                fireSnackBarMsg({ msg: "Please add Dish to start Bill process" });
            }
        }
    }, [paymentDetails, coupon, appliedCoupon]);

    const handleDelvSelectChange = useCallback((ev, payMethod) => {
        setOtherHomeDelv("Other" === payMethod);
        if (payMethod) {
            const onlineStatus = true;
            const rt = Number(paymentDetails.finalPrice);
            setPaymentDetails(prev => ({
                ...prev,
                delvName: payMethod,
                onlinePayMedium: "Other",
                onlinePayThrough: onlineStatus ? ONLINEPAY : "",
                payMedium: getBasePayMedium(false, onlineStatus),
                onlinePay: rt,
                cashPay: 0.0, //Assuming cashPay is always disabled for Home Delivery
            }));
        } else {
            setPaymentDetails(prev => ({
                ...prev,
                delvName: "",
            }))
        }
    }, [paymentDetails])

    const handleOnlineSelectChange = useCallback((event, payMethod) => {
        //printLog("handleOnlineSelectChange", payMethod);
        if (payMethod) {
            setPaymentDetails(prev => ({
                ...prev,
                onlinePayMedium: payMethod,
            }));
        } else {
            setPaymentDetails(prev => ({
                ...prev,
                onlinePayMedium: "",
            }))
        }
    }, []);

    const handleTripStatusChange = useCallback((val) => {
        const currentTripStatus = tripDetails.pTripStatus;
        const mCurrentValue = TRIP_STATUS_BACK.find((item) => item.name === val);
        const myPreviousValue = TRIP_STATUS_BACK.find((item) => item.name === currentTripStatus);

        if (isEmpty(currentTripStatus)) {
            // When Trip is not assigned
            if (TRIP_ASSIGNED === val && billType !== InternalBillType.Home) {
                showSnpDialogForUpdateStatus(
                    "Feature support only in Home delivery");
            } else {
                setTripDetails(prev => ({
                    ...prev,
                    tripStatus: isEmpty(val) ? prev.pTripStatus : val,
                }));
            }
        } else if (currentTripStatus === TRIP_RUNNING && mCurrentValue?.no < 5) {
            // Prevent updates to previous status, when Trip is running
            showSnpDialogForUpdateStatus(
                `Cannot Update previous Trip status (i.e. ${mCurrentValue?.name}) Current Status: ${currentTripStatus}`);
        } else if (myPreviousValue?.no > mCurrentValue?.no) {
            // Prevent updates to earlier statuses
            showSnpDialogForUpdateStatus(
                `Cannot Update previous Trip status (i.e. ${mCurrentValue?.name}) Current Status: ${currentTripStatus}`);
        } else {
            setTripDetails(prev => ({
                ...prev,
                tripStatus: isEmpty(val) ? prev.pTripStatus : val,
            }));
        }
    }, [tripDetails.pTripStatus, billType]);

    const handleRiderChange = useCallback(
        (val) => {
            const id = val?.riderId || "";
            const riderName = val?.riderIdName || "";

            setTripDetails(prev => ({
                ...prev,
                riderId: id,
                riderIdName: riderName,
            }));
        },
        []
    );

    const memorizedGstComponent = useMemo(() => {
        return (
            <Grid item xs={12}>
                <FormControlLabel
                    name="isGstAllowed"
                    disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                    checked={paymentDetails.isGstAllowed} control={<Checkbox />} onChange={handleInputChange}
                    label={
                        <p style={{ fontSize: "15px" }}>
                            {paymentDetails.isGstAllowed ? "Disable GST" : "Enable GST"}
                        </p>
                    } />
            </Grid>
        )
    }, [paymentDetails.isGstAllowed, isPaid, handleInputChange]);


    const memorizedOfferComponent = useMemo(() => {
        return (
            <Grid item xs={12}>
                <FormControl>
                    <CouponApply isPaid={isPaid}
                        isRoleAllowed={isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                        coupon={coupon}
                        appliedCoupon={appliedCoupon}
                        setCoupon={(val) => setCoupon(val)}
                        handleApply={handleApply}
                        handleRemove={handleRemove} />
                    <FormLabel id="billOffer">Any Offer :</FormLabel>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                        }}
                    >
                        <RadioGroup
                            aria-label="bofferDenom"
                            name="bofferDenom"
                            value={paymentDetails.takenDenom}
                            onChange={handleInputChange}
                            sx={{
                                display: "flex",
                                flexDirection: {
                                    xs: "row", // horizontal on mobile
                                    sm: "column", // vertical on tablet & up
                                },
                                flexWrap: "wrap",
                                gap: 0,
                                flex: {
                                    xs: "1 1 100%",
                                    sm: "1 1 auto",
                                },
                            }}
                        >
                            <FormControlLabel
                                disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) || appliedCoupon}
                                value={OfferType.No_Offer}
                                control={<Radio />}
                                label="No Offer"
                            />
                            <FormControlLabel
                                disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) || appliedCoupon}
                                value={OfferType.Flat}
                                control={<Radio />}
                                label="Flat"
                            />
                            <FormControlLabel
                                disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) || appliedCoupon}
                                value={OfferType.Percentage}
                                control={<Radio />}
                                label="In Percentage"
                            />
                        </RadioGroup>

                        {(paymentDetails.takenDenom > OfferType.No_Offer) && (
                            <TextField
                                id="bofferAmt"
                                name="bofferAmt"
                                variant="filled"
                                size="small"
                                disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE) || appliedCoupon}
                                label="Enter Offer Value"
                                value={paymentDetails.takenOffrAmt}
                                onChange={handleInputChange}
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "120px",
                                    },
                                    mt: {
                                        xs: 0,
                                        sm: 0,
                                    },
                                    ml: {
                                        xs: 0,
                                        sm: 0,
                                    },
                                }}
                            />
                        )}
                    </div>
                </FormControl>
            </Grid>
        )
    }, [isPaid, paymentDetails.takenDenom, paymentDetails.takenOffrAmt, handleInputChange, coupon, appliedCoupon]);

    const memorizedPaymentOption = useMemo(() => {
        return (
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <FormControlLabel disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)} name="onlinePayEnb"
                            checked={isOnlineEnabled(paymentDetails.payMedium)} control={<Checkbox />} label="Online" onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            id="online-select"
                            options={CART_INITIAL_STATE.onlinePayMethod}
                            autoHighlight
                            variant="filled"
                            size="small"
                            fullWidth
                            isOptionEqualToValue={(option, value) => {
                                if (!option) return false;
                                if (!value) return false;
                                return (option === value);
                            }}
                            onChange={handleOnlineSelectChange}
                            disabled={isPaid || (paymentDetails.payMedium !== PayMedium.ONLINE && paymentDetails.payMedium !== PayMedium.BOTH) || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            style={{ width: "70%", maxHeight: "50%" }}
                            getOptionLabel={(option) => option ?? ''}
                            value={paymentDetails.onlinePayMedium}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    {...props}
                                >
                                    {option}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Search Online Pay Method"
                                    inputProps={{
                                        ...params.inputProps,
                                    }}
                                />
                            )}
                        />

                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="onlinePayAmt"
                            name="onlinePayAmt"
                            variant="filled"
                            size="small"
                            style={{ width: "50%", maxHeight: "20%" }}
                            disabled={isPaid || paymentDetails.payMedium !== PayMedium.BOTH || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            label="Enter Online Amount"
                            value={paymentDetails.onlinePay}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    {
                        billType !== InternalBillType.Home && <Grid item xs={12}>
                            <FormControlLabel name="cashPayEnb" disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                                checked={isCashEnabled(paymentDetails.payMedium)} control={
                                    <Checkbox />
                                } label="Cash" onChange={handleInputChange} />
                        </Grid>
                    }
                    {
                        billType !== InternalBillType.Home &&
                        <Grid item xs={12}>
                            <TextField
                                id="cashPayAmt"
                                name="cashPayAmt"
                                variant="filled"
                                size="small"
                                style={{ width: "50%" }}
                                disabled={isPaid || paymentDetails.payMedium !== PayMedium.BOTH || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                                label="Enter Cash Amount"
                                value={paymentDetails.cashPay}
                                onChange={handleInputChange}
                            />
                        </Grid>
                    }
                </Grid>
            </Grid>
        )
    }, [isPaid, billType,
        paymentDetails,
        handleOnlineSelectChange,
        handleInputChange]);

    const renderHomeDeliveryAutocomplete = useMemo(() => {
        return (
            <Grid
                item
                xs={12}
                md={6}
            >
                <Autocomplete
                    id="home-select"
                    options={CART_INITIAL_STATE.homeDelvMethod}
                    autoHighlight
                    variant="filled"
                    size="small"
                    disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                    style={{ width: "100%", height: "50%" }}
                    onChange={handleDelvSelectChange}
                    isOptionEqualToValue={(option, value) => {
                        if (!option || !value) return false;
                        return option === value;
                    }}
                    getOptionLabel={(option) => option ?? ""}
                    value={paymentDetails.delvName}
                    renderOption={(props, option) => (
                        <Box component="li" key={option} {...props}>
                            {option}
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Home Delivery"
                            inputProps={{
                                ...params.inputProps,
                            }}
                        />
                    )}
                />
            </Grid>
        );
    }, [
        billType,
        isOthHomeDelv,
        isPaid,
        paymentDetails.delvName,
        CART_INITIAL_STATE.homeDelvMethod,
        handleDelvSelectChange,
    ]);

    const memorizedDelvOthers = useMemo(() => {
        return (
            <>
                {
                    isOthHomeDelv &&
                    <Grid item xs={12}
                        md={6}>
                        <TextField
                            id="delvNameOth"
                            name="delvNameOth"
                            variant="filled"
                            size="small"
                            disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            label="Enter Other Delivery Name"
                            value={delvNameOth}
                            onChange={handleInputChange}
                        />
                    </Grid>
                }
            </>
        )
    }, [isOthHomeDelv, delvNameOth, handleInputChange]);

    const memorizedDelvCharged = useMemo(() => {
        return (
            <>
                {!isEmpty(paymentDetails.delvName) &&
                    <Grid item xs={12}>
                        <TextField
                            id="delvCharge"
                            name="delvCharge"
                            variant="filled"
                            size="small"
                            disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            label="Enter Delivery Amount"
                            value={paymentDetails.delvCharge}
                            onChange={handleInputChange}
                        />
                    </Grid>
                }
            </>
        )
    }, [isPaid, paymentDetails.delvName, paymentDetails.delvCharge, handleInputChange]);

    const memorizedHomeDelvId = useMemo(() => {
        return (
            <>
                {
                    (hotelDelvTxn && !isEmpty(paymentDetails.delvName)) &&
                    <Grid item xs={12}>
                        <TextField
                            id="homeDelvId"
                            name="homeDelvId"
                            variant="filled"
                            size="small"
                            disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            label="Enter Delivery OrderId"
                            value={externalBillDetails.homeDelvId}
                            onChange={handleInputChange}
                        />
                    </Grid>
                }
            </>
        )
    }, [isPaid, hotelDelvTxn, paymentDetails.delvName, externalBillDetails.homeDelvId]);

    const memorizedHomeDelvOtp = useMemo(() => {
        return (
            <>
                {
                    (hotelDelvTxn && !isEmpty(paymentDetails.delvName)) &&
                    <Grid item xs={12}>
                        <TextField
                            id="homeDelvOtp"
                            name="homeDelvOtp"
                            variant="filled"
                            size="small"
                            disabled={isPaid || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            label="Enter Delivery OTP"
                            value={externalBillDetails.homeDelvOtp}
                            onChange={handleInputChange}
                        />
                    </Grid>
                }
            </>
        )
    }, [isPaid, hotelDelvTxn, paymentDetails.delvName, externalBillDetails.homeDelvOtp]);

    const memorizedTripStatusAutoComplete = useMemo(() => {
        return (
            <Autocomplete
                id="trip-select"
                options={TRIP_STATUS}
                disabled={TRIP_DELIVERED === tripDetails.pTripStatus}
                autoHighlight
                variant="filled"
                size="small"
                onChange={(e, val) => handleTripStatusChange(val)}
                style={{ width: "90%", maxHeight: "20%" }}
                isOptionEqualToValue={(option, value) => option === value}
                getOptionLabel={(option) => option || ""}
                value={tripDetails.tripStatus}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        {option}
                    </Box>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Update Trip/Food Status"
                        placeholder="Select Trip/Food Status"
                        inputProps={{ ...params.inputProps }}
                    />
                )}
            />
        );
    }, [tripDetails.pTripStatus,
    tripDetails.tripStatus,
        handleTripStatusChange
    ]);

    const memorizedRiderSelectAutocomplete = useMemo(() => {
        return (
            <Autocomplete
                id="rider-select"
                options={riders}
                autoHighlight
                disabled={TRIP_DELIVERED === tripDetails.pTripStatus}
                variant="filled"
                size="small"
                onChange={(e, val) => handleRiderChange(val)}
                style={{ width: "90%", maxHeight: "20%" }}
                isOptionEqualToValue={(option, value) => option?.riderId === value?.riderId}
                getOptionLabel={(option) => option?.riderIdName ?? ''}
                value={tripDetails}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        {`${option.riderIdName} (${option.mob})`}
                    </Box>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Assigned Rider"
                        helperText={
                            isEmpty(tripDetails.assignedByName)
                                ? ""
                                : `Assigned By ${tripDetails.assignedByName}`
                        }
                        placeholder="Select Rider"
                        inputProps={{
                            ...params.inputProps,
                        }}
                    />
                )}
            />
        );
    }, [tripDetails]);


    return (
        <Grid item xs={12}>
            <LoadingPaper elevation={0}
                loader={payLoader}
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#e3f2f9",
                    boxShadow: 1,
                    borderRadius: 5,
                    padding: 1,
                }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={10} sm={9} lg={10}>
                        <Grid container spacing={1}>
                            {billType === InternalBillType.Home &&
                                <Grid item md={5} xs={12} lg={5} sm={4}>
                                    < Grid container spacing={1}>
                                        {renderHomeDeliveryAutocomplete}
                                        {memorizedDelvOthers}
                                        {memorizedDelvCharged}
                                        {memorizedHomeDelvId}
                                        {memorizedHomeDelvOtp}
                                    </Grid>
                                </Grid>
                            }
                            <Grid item md={4} xs={12} lg={4} sm={4}>
                                <Grid container spacing={1}>
                                    {memorizedPaymentOption}
                                </Grid>
                            </Grid>
                            <Grid item md={3} xs={12} lg={3} sm={4}>
                                <Grid container spacing={1}>
                                    {memorizedGstComponent}
                                    {memorizedOfferComponent}
                                </Grid>
                            </Grid>
                            {
                                (tripDetails.tripUpdateReq
                                    || billedFrom === BillFromMachine.WEB) &&
                                <Grid item xs={12}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={3}>
                                            {memorizedTripStatusAutoComplete}
                                        </Grid>
                                        {
                                            (billType === InternalBillType.Home &&
                                                [TRIP_ASSIGNED, TRIP_RUNNING, TRIP_DELIVERED].includes(tripDetails.tripStatus))
                                            && <Grid item xs={12} md={3}>
                                                {memorizedRiderSelectAutocomplete}
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                            }
                            <Grid item xs={12}>
                                <Grid container spacing={1}>
                                    {
                                        externalBillDetails.payAtCounterOpt &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word',
                                                    fontSize: '16px'
                                                }}><u>** Note : User Choose to Pay At Counter **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (!isEmpty(externalBillDetails.hotelBillNo) && externalBillDetails.payLaterSignal) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word',
                                                    fontSize: '16px'
                                                }}><u>** Note : Payment of this bill will take care by Hotel **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (!isEmpty(externalBillDetails.transactionId)) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word',
                                                    fontSize: '16px'
                                                }}><u>{`** Transaction Id : ${externalBillDetails.transactionId} **`}</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (billStatus === BillStatus.HOMEDELIVERYINITIATED) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word',
                                                    fontSize: '16px'
                                                }}><u>** Failed to Initiate Pay By Customer,You can delete the bill **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (billStatus === BillStatus.HOMEDELIVERYCASHPAY) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word',
                                                    fontSize: '16px'
                                                }}><u>** Customer Selected Cash on Delivery **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (billStatus === BillStatus.PARTIALLYPAID) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap',
                                                    overflowWrap: 'break-word',
                                                    fontSize: '16px', color: "#2f1160"
                                                }}>
                                                    <u>** Partially Paid. To Check status click on Partial Pay/Clear Dues **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (billStatus === BillStatus.PAID && settleDown) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '16px' }}>
                                                    <u>** Full Paid & Settled **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        ((billedFrom === -1 || billedFrom === BillFromMachine.APP) &&
                                            billType !== InternalBillType.BookTable &&
                                            billStatus === BillStatus.PAID && !settleDown) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '16px',
                                                    color: "#641906"
                                                }}>
                                                    <u>** Full Paid & But not settled. Please settle the bill **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                    {
                                        (billedFrom === BillFromMachine.WEB &&
                                            tripDetails.tripStatus !== TRIP_DELIVERED && billStatus === BillStatus.PAID
                                            && !settleDown) &&
                                        <Grid item xs={12}>
                                            <center>
                                                <p style={{
                                                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '16px',
                                                    color: "#641906"
                                                }}><u>** Full Paid & Customer waiting for order **</u></p>
                                            </center>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={2} sm={3} lg={2}>
                        <Typography variant="subtitle4" component="div" style={{ fontFamily: "monospace", color: "#2f1160", whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '23px' }} ><u>Bill Summary:</u></Typography>
                        <Typography variant="subtitle4" component="div" style={{
                            color: "rgba(3, 56, 136, 0.88)", fontFamily: "monospace"
                            , whiteSpace: 'pre-wrap'
                            , overflowWrap: 'break-word'
                        }}  >Sub Total: ₹{paymentDetails.totalPrice}</Typography>
                        {
                            (paymentDetails.takenDenom === OfferType.Flat) &&
                            <Typography variant="subtitle4" component="div" style={{ color: "rgb(189, 116, 67)", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Offer Applied {"(- Flat )"} {paymentDetails.takenOffrAmt}</Typography>
                        }
                        {
                            (paymentDetails.takenDenom === OfferType.Percentage) &&
                            <Typography variant="subtitle4" component="div" style={{ color: "rgb(189, 116, 67)", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Offer Applied {"(-)"} {paymentDetails.takenOffrAmt + " %"}</Typography>
                        }
                        <Typography variant="subtitle4" component="div" style={{ color: "rgba(3, 56, 136, 0.88)", fontFamily: "monospace", whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px" }} >CGST{"(" + paymentDetails.cgst + "%):"} ₹{paymentDetails.cgstAmt}</Typography>
                        <Typography variant="subtitle4" component="div" style={{ color: "rgba(3, 56, 136, 0.88)", fontFamily: "monospace", whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "14px" }} >SGST{"(" + paymentDetails.sgst + "%):"} ₹{paymentDetails.sgstAmt}</Typography>
                        {
                            (paymentDetails.roundOff !== 0.0 || paymentDetails.roundOff !== -0.0) && !isNumberEmpty(paymentDetails.roundOff) &&
                            <Typography variant="subtitle4" component="div" style={{ color: "#A52A2A", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >RoundOff{paymentDetails.roundOff > 0.0 ? "(+)" : "(-)"} {paymentDetails.roundOff}</Typography>
                        }
                        {
                            loyalityPointDetails.isPointAdded &&
                            <Typography variant="subtitle4" component="div" style={{ color: "#A52A2A", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Royality Point(-) ₹{loyalityPointDetails.pointRedeem}</Typography>
                        }
                        {paymentDetails.delvCharge > 0.0 &&
                            <Typography variant="subtitle4" component="div" style={{ color: "#A52A2A", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Delivery Charge ₹{paymentDetails.delvCharge}</Typography>
                        }
                        <Typography variant="subtitle4" component="div" style={{ color: "rgba(4, 63, 34, 0.88)", fontWeight: "bold", fontFamily: "monospace", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Grand Total: ₹{paymentDetails.finalPrice}</Typography>
                        <TextField
                            id="cashTender"
                            name="cashTender"
                            variant="filled"
                            size="small"
                            style={{ width: "50%" }}
                            disabled={isPaid || paymentDetails.payMedium <= PayMedium.ONLINE || !isRoleAllowed([BILLMGMT, ONLINEBILLMGMT], ROLE_CREATE)}
                            label="Enter Cash Tender"
                            value={paymentDetails.cashTender}
                            onChange={handleInputChange}
                            sx={{
                                marginTop: 2,
                            }}

                        />
                        {
                            paymentDetails.cashReturn > 0.0 &&
                            <Typography variant="subtitle4" component="div" style={{ color: "#A52A2A", whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }} >Cash Return: ₹{paymentDetails.cashReturn}</Typography>
                        }
                    </Grid>
                </Grid>
            </LoadingPaper>
        </Grid>
    )
};

export default React.memo(RestoBillPayScreen);